module.exports = __webpack_public_path__ + "img/DocSend.c60c33a9.png";